import { render, staticRenderFns } from "./StudentMaterialsView.vue?vue&type=template&id=2ea3f53e&"
import script from "./StudentMaterialsView.vue?vue&type=script&lang=js&"
export * from "./StudentMaterialsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports